module.exports = __webpack_public_path__ + "static/media/Nicolette Belczak Headshot.4acf7bfc.jpeg";